import api from '../../api/core/api';
import {
  ApiResponse,
  DesktopDocumentType,
  DesktopPrintDocument,
  DesktopPrintingCapabilities,
} from './printing.types';

export const desktopPrintingApi = {
  async getCapabilities(): Promise<DesktopPrintingCapabilities> {
    const response = await api.get<ApiResponse<DesktopPrintingCapabilities>>(
      '/printing/desktop/v1/capabilities'
    );
    return response.data.data;
  },

  async getDocument(
    documentType: DesktopDocumentType,
    documentId: number
  ): Promise<DesktopPrintDocument> {
    const response = await api.get<ApiResponse<DesktopPrintDocument>>(
      `/printing/desktop/v1/documents/${documentType}/${documentId}`
    );
    return response.data.data;
  },
};
